export const convertCurrencyHexToChar = (currencyHex: string) => {
  if (!currencyHex) {
    return '';
  }
  return currencyHex.replace(/&#([a-zA-Z0-9]+);/g, function (match, group1) {
    return String.fromCharCode(parseInt('0' + group1));
  });
};
